import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";

export default function ServiceCard({ icon: Icon, title, description, index }) {
  return (
    <motion.div
      data-testid={`service-card-${index}`}
      initial={{ opacity: 0, y: 26 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1], delay: (index % 3) * 0.08 }}
      className="group eq-card rounded-2xl p-8"
    >
      <div className="flex items-start justify-between">
        <div className="w-12 h-12 rounded-xl bg-blue-500/10 border border-blue-500/30 grid place-items-center text-blue-300 transition-all duration-300 group-hover:scale-110 group-hover:shadow-[0_0_22px_rgba(10,132,255,0.45)]">
          <Icon className="w-5 h-5" strokeWidth={1.6} />
        </div>
        <ArrowUpRight
          className="w-5 h-5 text-gray-600 transition-all duration-300 group-hover:text-blue-400 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
          strokeWidth={1.6}
        />
      </div>
      <h3 className="mt-6 font-display text-xl font-semibold tracking-tight">{title}</h3>
      <p className="mt-3 text-sm text-gray-400 leading-relaxed">{description}</p>
    </motion.div>
  );
}
